<template>
  <a-flex vertical justify="space-between" class="side">
    <a-flex class="side-logo" justify="space-evenly" align="center">
      <a-avatar src="/img/logo.svg" shape="square" size="large"/>
      <a-typography-text type="secondary">活动编辑器</a-typography-text>
    </a-flex>
    <a-menu :items="editor.active.menu.items" :inline-collapsed="editor.active.menu.toggle"
            :open-keys="editor.active.menu.openKeys" v-model:selected-keys="editor.active.menu.selectedKeys"
            mode="inline" @click="editor.onMenuClick($event)"/>
    <div class="action-wrap">
      <a-flex vertical gap="middle" class="action">
        <a-button size="large" :icon="h(SettingOutlined)" @click="info.opt=true"
                  :loading="editor.active.status.loading">
          功能定制
        </a-button>
        <a-button danger size="large" :icon="h(LogoutOutlined)" @click="$router.push('/activities')"
                  :loading="editor.active.status.loading">
          退出编辑
        </a-button>
        <a-button v-if="!editor.meta.publish_at && editor.meta.activity_id" size="large" :icon="h(SaveOutlined)"
                  type="default"
                  :loading="editor.active.status.loading" @click="editor.save()">
          保存活动
        </a-button>
        <a-button v-if="!editor.meta.publish_at" size="large" :icon="h(SendOutlined)" type="primary"
                  :loading="editor.active.status.loading" @click="editor.publish()">发布活动
        </a-button>
      </a-flex>
    </div>
    <a-drawer v-model:open="info.opt" title="功能定制" size="large" :root-style="{ position: 'absolute' }"
              :body-style="{padding: 0}" destroy-on-close>
      <fragment-options/>
    </a-drawer>
  </a-flex>
</template>

<script setup lang="ts">

import {h, reactive} from "vue";
import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";
import {LogoutOutlined, SaveOutlined, SendOutlined, SettingOutlined} from "@ant-design/icons-vue";
import FragmentOptions from "@/views/editor/components/system/FragmentOptions.vue";

const editor = useRoute().meta.editor as AEditor;
const info = reactive({opt: false})

/**
 create table activity.scenes(
 scene_id varchar(22) not null primary key,
 agent_id varchar(22) not null references agents(agent_id) deferrable,
 activity_id varchar(22) not null references activities(activity_id) deferrable,
 brand_id varchar(22) not null references brands(brand_id) deferrable,
 branch_id varchar(22) not null references branches(branch_id) deferrable,
 activity_employee_id varchar(22) not null references activity.employees(activity_employee_id) deferrable,
 upper_activity_customer_id varchar(22) references activity.customers(activity_customer_id) deferrable,
 attrs jsonb not null default '{}',
 unique (activity_employee_id,upper_activity_customer_id));

 create table activity.orders(
 wechat_prepay_id varchar(36) not null,
 expire_at timestamptz not null,
 transaction_id varchar(28),
 amount numeric(8,2) not null,
 wechat_profit_sharing_amount numeric(8,2) not null default 0,
 refund_amount numeric(8,2) not null default 0,
 primary key (sign_id),
 foreign key (session_id) references activity.sessions(session_id) match simple on update cascade on delete cascade deferrable) inherits (activity.signs);
 */
</script>

<style scoped lang="sass">
.side
  width: 233px
  height: 100%
  user-select: none

  .ant-menu
    border-inline-end: 0
    overflow-y: auto
    flex: 1
    scrollbar-width: none
    -ms-overflow-style: none
    padding: 0 12px 12px 12px
    margin-top: -8px
    background-color: var(--ant-color-bg-base)

    :deep(.anticon)
      //box-sizing: border-box
      //padding: 4px
      background-color: rgba(0, 0, 0, 0.06)
      border-radius: 2px
      box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.06)

  .side-logo
    height: 70px
    width: 160px
    margin-left: 8px

    > .ant-typography
      font-size: 20px
      color: var(--ant-color-text-base)


  > .action-wrap
    overflow: hidden

    > .action
      padding: 12px
      flex-shrink: 0
      background-color: var(--ant-color-bg-base)
      box-shadow: 0 -10px 16px 16px var(--ant-color-bg-base)
      z-index: 2

:deep(.anticon)::before
  content: ''
  position: absolute
  top: -4px
  left: -4px
  right: -4px
  bottom: -4px
  background-color: rgba(0, 0, 0, 0.06)
  border-radius: 6px
  z-index: -1


  //:deep(.ant-menu-item)
    //border: rgba(0, 0, 0, 0.12) 1px dashed
    //margin-top: 6px

  :deep(.ant-menu-item-danger)
    border: #ff4d4f 1px dashed !important

.menu-custom
  > .moving
    opacity: 0.1


</style>